function normalizeCell(cell) {
  if (cell && typeof cell === 'object' && !Array.isArray(cell)) {
    return { ...cell, value: cell.value ?? '' };
  }
  return { value: cell ?? '' };
}

function cloneGrid(data, rowCount, columnCount) {
  return Array.from({ length: rowCount }, (_, rowIndex) => {
    const sourceRow = Array.isArray(data?.[rowIndex]) ? data[rowIndex] : [];
    return Array.from({ length: columnCount }, (_, columnIndex) => normalizeCell(sourceRow[columnIndex]));
  });
}

function Spreadsheet({
  data = [],
  onChange,
  className = '',
  columnLabels = []
}) {
  const rowCount = Math.max(Array.isArray(data) ? data.length : 0, 1);
  const columnCount = Math.max(
    Array.isArray(columnLabels) ? columnLabels.length : 0,
    Array.isArray(data) && data.some(row => Array.isArray(row) ? row.length : 0)
      ? Math.max(...data.map(row => (Array.isArray(row) ? row.length : 0)))
      : 0,
    1
  );
  const grid = cloneGrid(data, rowCount, columnCount);
  const headers = Array.from({ length: columnCount }, (_, index) => columnLabels[index] || `Columna ${index + 1}`);

  const handleCellChange = (rowIndex, columnIndex, value) => {
    if (typeof onChange !== 'function') return;
    const next = cloneGrid(grid, rowCount, columnCount);
    next[rowIndex][columnIndex] = {
      ...next[rowIndex][columnIndex],
      value
    };
    onChange(next);
  };

  return (
    <div className={`Spreadsheet ${className}`.trim()}>
      <table className="Spreadsheet__table">
        <thead>
          <tr>
            <th className="Spreadsheet__corner" aria-hidden="true" />
            {headers.map((header, index) => (
              <th key={`spreadsheet-header-${index}`} className="Spreadsheet__header">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {grid.map((row, rowIndex) => (
            <tr key={`spreadsheet-row-${rowIndex}`}>
              <th className="Spreadsheet__row-header" scope="row">
                {rowIndex + 1}
              </th>
              {row.map((cell, columnIndex) => (
                <td key={`spreadsheet-cell-${rowIndex}-${columnIndex}`} className="Spreadsheet__cell">
                  <input
                    type="text"
                    inputMode="text"
                    value={cell.value ?? ''}
                    onChange={event => handleCellChange(rowIndex, columnIndex, event.target.value)}
                    aria-label={`Fila ${rowIndex + 1}, ${headers[columnIndex] || `columna ${columnIndex + 1}`}`}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Spreadsheet;
